import { BaseStore } from "../../../../react-core/Flux/BaseStore";
import { TransferRequestDispatcher } from "./Variable";
import { ActionType } from "../../../../react-core/Flux/ActionType";
import { AccountTransferInstruction } from "../../../../Wrap/Models/Models/Transfer/AccountTransferInstruction";

export interface TransferRequestStoreStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: AccountTransferInstruction;
}

export class TransferRequestStoreStatic extends BaseStore<TransferRequestStoreStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(TransferRequestDispatcher, (actionData) =>
            this.onTransferRequestStoreResponse(actionData)
        );
    }


    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getTransferRequest() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): TransferRequestStoreStaticState {
        return {
            actionType: ActionType.Loading,
            data: null,
            isLoading: false,
        };
    }

    private onTransferRequestStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: ActionType.Success, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: ActionType.Error });
                break;
            case ActionType.Loading:
                this.setState({ isLoading: actionData.payload, actionType: ActionType.Loading });
                break;
        }
    }
}
